/* eslint-disable react-refresh/only-export-components -- модуль-карта иконок:
   экспортирует константы вместе с двумя кастомными SVG-иконками */
import { SvgIcon, type SvgIconProps } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import StarIcon from "@mui/icons-material/Star";
import FlagIcon from "@mui/icons-material/Flag";
import SportsFootballIcon from "@mui/icons-material/SportsFootball";
import SportsBasketballIcon from "@mui/icons-material/SportsBasketball";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import SportsBaseballIcon from "@mui/icons-material/SportsBaseball";
import SportsHockeyIcon from "@mui/icons-material/SportsHockey";
import SportsTennisIcon from "@mui/icons-material/SportsTennis";
import SportsVolleyballIcon from "@mui/icons-material/SportsVolleyball";
import SportsGolfIcon from "@mui/icons-material/SportsGolf";
import SportsHandballIcon from "@mui/icons-material/SportsHandball";
import SportsRugbyIcon from "@mui/icons-material/SportsRugby";
import SportsMmaIcon from "@mui/icons-material/SportsMma";
import SportsKabaddiIcon from "@mui/icons-material/SportsKabaddi";
import SportsMotorsportsIcon from "@mui/icons-material/SportsMotorsports";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import PoolIcon from "@mui/icons-material/Pool";
import DownhillSkiingIcon from "@mui/icons-material/DownhillSkiing";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import SportsIcon from "@mui/icons-material/Sports";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import TimerIcon from "@mui/icons-material/Timer";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import CelebrationIcon from "@mui/icons-material/Celebration";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import MovieIcon from "@mui/icons-material/Movie";
import VideocamIcon from "@mui/icons-material/Videocam";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import MicIcon from "@mui/icons-material/Mic";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import ReplayIcon from "@mui/icons-material/Replay";
import SpeedIcon from "@mui/icons-material/Speed";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import BoltIcon from "@mui/icons-material/Bolt";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import SentimentVerySatisfiedIcon from "@mui/icons-material/SentimentVerySatisfied";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import InsightsIcon from "@mui/icons-material/Insights";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import SlowMotionVideoIcon from "@mui/icons-material/SlowMotionVideo";

// Кастомные SVG-иконки судейских карточек (порт из референсного
// TimecodeMarkers.js — таких нет в @mui/icons-material)
const RedCardIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <rect
      x="6"
      y="3"
      width="12"
      height="18"
      rx="2"
      ry="2"
      fill="#DC2626"
      stroke="#B91C1C"
      strokeWidth="0.5"
    />
  </SvgIcon>
);

const YellowCardIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <rect
      x="6"
      y="3"
      width="12"
      height="18"
      rx="2"
      ry="2"
      fill="#FBBF24"
      stroke="#F59E0B"
      strokeWidth="0.5"
    />
  </SvgIcon>
);

export const DEFAULT_TIMECODE_ICON = FlagIcon;

// Порт ICON_MAP референсного TimecodeMarkers.js — ключи совпадают с enum
// TimecodeIcon site-схемы.
export const ICON_MAP: Record<string, typeof SvgIcon | typeof RedCardIcon> = {
  // Общие иконки
  PLAY_ARROW: PlayArrowIcon,
  STAR: StarIcon,
  FLAG: FlagIcon,
  TIMER: TimerIcon,
  TROPHY: EmojiEventsIcon,
  FIRE: WhatshotIcon,
  LIGHTNING: FlashOnIcon,
  BOLT: BoltIcon,
  AWESOME: AutoAwesomeIcon,
  CELEBRATION: CelebrationIcon,
  TRENDING: TrendingUpIcon,
  SPORTS: SportsIcon,

  // Арбитраж и карточки
  WHISTLE: SportsIcon,
  RED_CARD: RedCardIcon,
  YELLOW_CARD: YellowCardIcon,

  // Видео и контент
  MOVIE: MovieIcon,
  VIDEOCAM: VideocamIcon,
  CAMERA: CameraAltIcon,
  MIC: MicIcon,
  PLAY_CIRCLE: PlayCircleIcon,
  REPLAY: ReplayIcon,
  SLOW_MOTION: SlowMotionVideoIcon,
  SPEED: SpeedIcon,
  VOLUME_UP: VolumeUpIcon,
  FULLSCREEN: FullscreenIcon,
  RECORD_VOICE: RecordVoiceOverIcon,

  // Эмоциональные реакции
  HEART: FavoriteIcon,
  THUMB_UP: ThumbUpIcon,
  THUMB_DOWN: ThumbDownIcon,
  EMOTIONS: EmojiEmotionsIcon,
  VERY_SATISFIED: SentimentVerySatisfiedIcon,
  HOT_FIRE: LocalFireDepartmentIcon,
  INSIGHTS: InsightsIcon,

  // Командные виды спорта
  FOOTBALL: SportsFootballIcon,
  BASKETBALL: SportsBasketballIcon,
  SOCCER: SportsSoccerIcon,
  HOCKEY: SportsHockeyIcon,
  VOLLEYBALL: SportsVolleyballIcon,
  BASEBALL: SportsBaseballIcon,
  RUGBY: SportsRugbyIcon,
  HANDBALL: SportsHandballIcon,

  // Индивидуальные виды спорта
  TENNIS: SportsTennisIcon,
  GOLF: SportsGolfIcon,
  RUNNING: DirectionsRunIcon,
  SWIMMING: PoolIcon,
  SKIING: DownhillSkiingIcon,
  FITNESS: FitnessCenterIcon,

  // Боевые искусства
  MMA: SportsMmaIcon,
  KABADDI: SportsKabaddiIcon,

  // Автоспорт и киберспорт
  MOTORSPORTS: SportsMotorsportsIcon,
  ESPORTS: SportsEsportsIcon,
};
